import {environment} from '../../../environments/environment';

export class Helpers {

  static getGoogleMapsLink(): string {
    return `https://www.google.com/maps/place/${environment.company.address.street1.replace(' ', '+')},+${environment.company.address.city},+${environment.company.address.region}+${environment.company.address.postalCode}/`;
  }
}
